import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@material-ui/core';
import { usePhoneView } from '@michelin/acid-components';
import { ClosableDialogContent, ClosableDialogTitle } from '../../../compositions/ClosableDialog';
import { ExpandablePanels } from './ExpandablePanels';
export function FaqDialog(_a) {
    var faqs = _a.faqs, closeDialog = _a.closeDialog, open = _a.open;
    var t = useTranslation().t;
    var phoneView = usePhoneView();
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: open, onClose: closeDialog, fullWidth: true, maxWidth: "md", fullScreen: phoneView },
            React.createElement(ClosableDialogTitle, { onClose: closeDialog }, t('Help Center')),
            React.createElement(ClosableDialogContent, { dividers: true, style: { height: phoneView ? undefined : '70vh' } },
                React.createElement(ExpandablePanels, { faqs: faqs })))));
}
//# sourceMappingURL=FaqDialog.js.map